export const WALLET_ACCOUNT_CONNECTED = 'WALLET_ACCOUNT_CONNECTED';
export const WALLET_ACCOUNT_DISCONNECT = 'WALLET_ACCOUNT_DISCONNECT'
export const MAX_APPROOVE_COUNT = 'MAX_APPROOVE_COUNT'
export const GET_BUSD_BALANCE = 'GET_BUSD_BALANCE'
export const CURRENT_BUSD_RATE = 'CURRENT_BUSD_RATE'


